import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NotificationsCenterComponent } from './notifications-center.component';
import { NotificationsCenterRoutingModule } from './notifications-center-routing.module';



@NgModule({
  declarations: [
    NotificationsCenterComponent
  ],
  imports: [
    CommonModule,
    NotificationsCenterRoutingModule
  ],
  exports: [
    NotificationsCenterComponent
  ]
})
export class NotificationsCenterModule { }
